var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtimeAndDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H3C2.20536 0.00329046 1.44421 0.320417 0.882315 0.882315C0.320418 1.44421 0.00329046 2.20536 0 3V25C0.00329046 25.7946 0.320418 26.5558 0.882315 27.1177C1.44421 27.6796 2.20536 27.9967 3 28H15C15.7946 27.9967 16.5558 27.6796 17.1177 27.1177C17.6796 26.5558 17.9967 25.7946 18 25V3C17.9967 2.20536 17.6796 1.44421 17.1177 0.882315C16.5558 0.320417 15.7946 0.00329046 15 0ZM3 2H15C15.2652 2 15.5196 2.10536 15.7071 2.29289C15.8946 2.48043 16 2.73478 16 3V4H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2ZM15 26H3C2.73478 26 2.48043 25.8946 2.29289 25.7071C2.10536 25.5196 2 25.2652 2 25V24H16V25C16 25.2652 15.8946 25.5196 15.7071 25.7071C15.5196 25.8946 15.2652 26 15 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtimeAndDataIcon);
export default __webpack_public_path__ + "static/media/airtimeAndDataIcon.31df0105a7f035137bf17f94e4b8f325.svg";
export { ForwardRef as ReactComponent };